// ============================================================
// useLeave - how a bench is left (the weapon bench, the module bench).
// ============================================================
import { useCallback, useState } from 'react';
import useEscapeKey from '../../hooks/useEscapeKey.js';

/**
 * Cancel discards (it says so); Escape, easier to press by accident, asks first when there are changes. `asking` is
 * whether the bench shows its "Discard the changes?" line.
 */
export default function useLeave(active: boolean, dirty: boolean, onClose: () => void) {
  const [asking, setAsking] = useState(false);
  const tryClose = useCallback(() => (dirty ? setAsking(true) : onClose()), [dirty, onClose]);
  useEscapeKey(active, tryClose);
  return { asking, setAsking, tryClose };
}
